module.exports = __webpack_public_path__ + "img/payname3.73e60e7d.png";